<!--
Author: TangChen
Date: 2018-10-17
Desc: 绑定交易账户，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-bind-old-acct bizcomp ' + className">
        <comp-title :title="title" />
        <nav-tips :data="titTips" />
        <bind-acct :way="way" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import navTips from "@/components/form/navTips.vue";
import bindAcct from "@/components/acctInfo/bindAcct.vue";
export default {
    name: "BindOldAcct",
    components: {
        navTips,
        bindAcct
    },
    mixins: [mixin],
    data () {
        return {
            titTips: {
                tit: "您还未绑定交易账号",
                text: "进行基金买入、卖出、定投等操作需要绑定交易账号",
                cla: "bank"
            },
            way: true
        };
    },
    methods: {
    // 账户绑定选项处理
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.bizcomp-bind-old-acct {
}
</style>
